import {
  Brightness4 as Brightness4Icon,
  Brightness7 as Brightness7Icon,
  BrightnessAuto as BrightnessAutoIcon,
  ViewList as ViewListIcon,
} from '@mui/icons-material'
import {
  AppBar,
  Container,
  createTheme,
  IconButton,
  Link,
  Theme,
  ThemeOptions,
  ThemeProvider,
  Toolbar,
  useColorScheme,
} from '@mui/material'
import useFeatureFlags from '@src/data/api/featureSwitch-api/featureSwitch-api'
import { merge } from 'lodash-es'
import { type JSX } from 'react'
import AppMenu from './AppMenu'
import CompanySelector from './CompanySelector'
import LanguagePicker from './LanguagePicker'
import PromotionsMenu from './PromotionsMenu'
import ReportMenu from './ReportMenu'
import TerritoriesMenu from './TerritoriesMenu'
import UserMenu from './UserMenu'

interface AppHeaderProps {
  hasAlertBanner?: boolean
}

const innerTheme = (theme: Theme) => {
  const iTheme: ThemeOptions = {
    components: {
      MuiButton: {
        defaultProps: {
          variant: 'text',
          color: 'inherit',
        },
      },
      MuiIconButton: {
        defaultProps: {
          color: 'inherit',
        },
      },
      MuiSelect: {
        styleOverrides: {
          icon: {
            color: 'inherit',
          },
        },
      },
      MuiInputBase: {
        styleOverrides: {
          input: {
            color: 'inherit',
          },
          root: {
            color: 'inherit',
          },
        },
      },
      MuiInput: {
        styleOverrides: {
          root: {
            ':before': {
              borderColor: 'white',
            },
            ':hover': {
              ':before': {
                borderColor: 'white !important',
              },
            },
          },
        },
      },
    },
  }
  return createTheme(merge(theme, iTheme))
}

const Layout = ({ hasAlertBanner = false }: AppHeaderProps): JSX.Element => {
  const { mode, setMode } = useColorScheme()

  const [featureFlags] = useFeatureFlags()

  return (
    <AppBar
      position="sticky"
      sx={[
        {
          backgroundColor: 'rgb(0, 0, 89)',
          color: 'white',
          mb: 10,
        },
        hasAlertBanner
          ? {
              top: 48,
            }
          : {
              top: 0,
            },
      ]}
    >
      <Container maxWidth="xl" disableGutters>
        <ThemeProvider theme={innerTheme}>
          <Toolbar>
            <div className="icebergBanner">
              <img src="/images/iceberg-no-bg.png" alt="Iceberg Finance" style={{ width: '110px', height: '40px' }} />
            </div>
            <Link href="/">
              <IconButton>
                <ViewListIcon sx={{ color: '#ffffff' }} />
              </IconButton>
            </Link>
            <span style={{ flexGrow: 1 }}>&nbsp;</span>
            <CompanySelector />
            <AppMenu />
            <TerritoriesMenu />
            <ReportMenu />
            {featureFlags?.useIFXMerchantPromotions && <PromotionsMenu />}
            <UserMenu />
            <LanguagePicker />
            <IconButton onClick={() => setMode(mode === 'system' ? 'light' : mode === 'light' ? 'dark' : 'system')}>
              {mode === 'system' ? (
                <BrightnessAutoIcon sx={{ color: '#ffffff' }} />
              ) : mode === 'dark' ? (
                <Brightness4Icon sx={{ color: '#ffffff' }} />
              ) : (
                <Brightness7Icon sx={{ color: '#ffffff' }} />
              )}
            </IconButton>
          </Toolbar>
        </ThemeProvider>
      </Container>
    </AppBar>
  )
}
export default Layout
